export function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function replaceContainerHtml(container, html) {
  container.replaceChildren();
  if (!html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  for (const node of doc.body.childNodes) {
    container.appendChild(node.cloneNode(true));
  }
}

export function appendParsedHtml(container, html, position = 'beforeend') {
  if (!html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  for (const node of doc.body.childNodes) {
    container.insertAdjacentElement(position, node.cloneNode(true));
  }
}

export function createFieldGroup(label, value, row = false) {
  const group = document.createElement('div');
  group.className = row ? 'cart__acc-field-row' : 'cart__acc-field-group';
  const labelEl = document.createElement('span');
  labelEl.className = row ? 'cart__acc-field-key' : 'cart__acc-field-label';
  labelEl.textContent = label;
  const valueEl = document.createElement('span');
  valueEl.className = 'cart__acc-field-value';
  valueEl.textContent = value;
  group.appendChild(labelEl);
  group.appendChild(valueEl);
  return group;
}
